
export const UPSERT_CHAT_LOG = '@chat/UPSERT_CHAT_LOG';
export const UPSERT_CHAT_LOG_SUCCESS = '@chat/UPSERT_CHAT_LOG_SUCCESS';
export const UPSERT_CHAT_LOG_FAIL = '@chat/UPSERT_CHAT_LOG_FAIL';

export const DELETE_CHAT_LOG = '@chat/DELETE_CHAT_LOG';
export const DELETE_CHAT_LOG_SUCCESS = '@chat/DELETE_CHAT_LOG_SUCCESS';
export const DELETE_CHAT_LOG_FAIL = '@chat/DELETE_CHAT_LOG_FAIL';
